import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CoursesService } from '../services/courses.service';

@Injectable({
  providedIn: 'root'
})
export class AdminCoursesResolver implements Resolve<any> {
  constructor(private coursesService: CoursesService, private auth: AuthService, private router: Router, private flashMessage: FlashMessagesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return of(this.coursesService).pipe(
      switchMap(() => {
        // reject users to visit pages to admin courses
        if (!this.auth.isSuperAdmin) {
          this.showError('Page is not available.');
          this.router.navigate(['/courses']);
          return EMPTY;
        }

        if (!this.auth.isSuperAdmin) {
          return of([]);
        }

        // check if already loaded
        const loaded = this.coursesService.userCourses ? false : this.coursesService.courses.length > 0;

        let cachedData = null as any;

        if (loaded) {
          cachedData = of({
            courses: this.coursesService.courses,
          });
        }

        const observable = cachedData || this.coursesService.getAllCourses({ getmodules: true });

        // Request courses from the database for this User
        return observable.pipe(
          switchMap((res: any) => {
            this.coursesService.userCourses = false;
            this.coursesService.courses = res.courses;

            this.coursesService.reloadCurrentCourse();

            if (route.data.course) {
              this.coursesService.setCurrentCourseBy(route.data.course);
            }

            if (route.queryParams.courseid) {
              this.coursesService.setCurrentCourseBy(route.queryParams.courseid);
            }

            if (route.queryParams.moduleid) {
              this.coursesService.setCurrentModuleBy(route.queryParams.moduleid);
            }

            return of(res);
          })
        );
      })
    );
  }

  private showError(message: string) {
    console.warn(message);
    this.flashMessage.show(message, {
      cssClass: 'alert-danger',
      timeout: 3000
    });
  }
}
